import React from 'react';
import styles from '../OrderStatus.module.css';

const CoreReturnsDetails = (props) => {
  return (
    <>
      <h2 className={styles.heading}>Core Return(s) Issued</h2>
      {props.coreReturns.map((cr) => {
        return (
          <table key={cr.core_return_id}>
            <tbody>
              <tr>
                <td className={styles.detailTitle}>
                  <strong>CR#:</strong>
                </td>
                <td className={styles.detail}>
                  <strong>{cr.core_return_id}</strong>
                </td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <a
                    target='_blank'
                    rel="noreferrer"
                    href={cr.formLink}
                  >
                    Print Core Return Form
                  </a>
                </td>
              </tr>
              <tr>
                <td className={styles.detailTitle}>
                  <strong>Received:</strong>
                </td>
                <td className={styles.detail}>
                  {cr.core_return_date_received}
                </td>
              </tr>
              <tr>
                <td className={styles.detailTitle}>
                  <strong>Part on Core:</strong>
                </td>
                <td className={styles.detail}>
                  <a href={cr.product.link}>{cr.product.product_id}</a>{' (' + cr.product.product_name + ')'}
                </td>
              </tr>
              <tr>
                <td className={styles.detailTitle}>
                  <strong>Core Value:</strong>
                </td>
                <td className={styles.detail}>
                  ${cr.core_return_amount}
                </td>
              </tr>
            </tbody>
          </table>
        );
      })}
    </>
  );
};

export default CoreReturnsDetails;